
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../_services/auth_service';
import { RedirectService } from '../_services/redirect_service';
import {HttpResponse} from "@angular/common/http";
import {of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {environment} from "../../environments/environment";

export const AuthAdminGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const redirect = inject(RedirectService);

    return authService.getUserData().pipe(
        map((response: HttpResponse<any>) => {
            // Controlla se il ruolo è 'amministratore'
            const isAdmin = response.body?.ruolo === 'amministratore' || response.body?.ruolo === 'operatore' ;
            return isAdmin;
        }),
        catchError((error) => {
            // In caso di errore, impedisci la navigazione
            if (!environment.production) {
                console.error('Errore durante la verifica del ruolo:', error);
            }
            redirect.save(state.url);
            return of(router.createUrlTree(['/login']));
        })
    );
};
